export default __webpack_public_path__ + "static/media/IRANSansWeb(FaNum).e2b04369.woff2";